<template>
  <v-container class="content-wrapper" fluid>
    <!-- Toggle Buttons -->
    <v-row class="mt-2">
      <v-spacer></v-spacer>
      <v-col cols="2"></v-col>
      <v-col cols="12" sm="6" md="6" class="d-flex justify-center">
        <v-row no-gutters class="d-flex justify-center overflow-x-auto">
          <v-btn-toggle v-model="toggleTab" rounded mandatory class="d-flex">
            <v-btn
              v-if="!filtered"
              value="hosting-institution"
              class="btn-selected"
              @click="toggleTab = 'hosting-institution'"
            >
              Hosting Institution
            </v-btn>
            <v-btn
              v-show="!filtered"
              value="view-all"
              class="btn-selected"
              @click="toggleTab = 'view-all'"
            >
              View All
            </v-btn>
          </v-btn-toggle>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col
        v-if="toggleTab === 'view-all'"
        cols="8"
        xl="8"
        lg="12"
        md="12"
        sm="12"
        class="d-flex justify-end"
      >
        <v-select
          v-model="sortBy"
          :items="itemsSortBy"
          dense
          style="max-width: 245px"
          outlined
          label="Sort By"
          rounded
          hide-details
          return-object
          @input="changeSortBy"
        >
        </v-select>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <!-- Filters -->
    <v-row class="mt-0">
      <v-spacer></v-spacer>
      <v-col cols="12" xl="2" lg="3" md="3" sm="12" xs="12">
        <v-row>
          <v-col cols="12">
            <v-card elevation="3" style="border-radius: 24px;">
              <v-card-text>
                <v-text-field
                  v-model.trim="patent.text"
                  rounded
                  placeholder="Search"
                  outlined
                  dense
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                ></v-text-field>
              </v-card-text>
              <v-card-text class="my-0 py-0">
                <label class="primary200--text">Filling Date:</label>
                <v-menu
                  v-model="fillingDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="fillingDateRangeText"
                      append-icon="mdi-calendar"
                      placeholder="Any Filling Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="patent.fillingDate"
                    range
                    @change="fillingDateMenu = false"
                    color="rgba(157, 87, 244, 1)"
                    :first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
              </v-card-text>
              <v-card-text class="my-0 py-0">
                <label class="primary200--text">Issue Date:</label>
                <v-menu
                  v-model="issueDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="issueDateRangeText"
                      append-icon="mdi-calendar"
                      placeholder="Any Issue Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="patent.issueDate"
                    range
                    @change="issueDateMenu = false"
                    color="rgba(157, 87, 244, 1)"
                    :first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
              </v-card-text>
              <v-card-text class="my-0 py-0">
                <label class="primary200--text">Expiration Date:</label>
                <v-menu
                  v-model="expirationDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="expirationDateRangeText"
                      append-icon="mdi-calendar"
                      placeholder="Any Expiration Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="patent.expirationDate"
                    range
                    @change="expirationDateMenu = false"
                    color="rgba(157, 87, 244, 1)"
                    :first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Patent Status:</label>
                <v-autocomplete
                  v-model="patent.patentStatus"
                  class="mt-2"
                  :items="patentStatusItems"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Patent Status'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Technology:</label>
                <v-autocomplete
                  v-model="patent.technology"
                  class="mt-2"
                  :items="technologies"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Technologoy'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Providers:</label>
                <v-autocomplete
                  v-model="patent.providers"
                  class="mt-2"
                  :items="providers"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Providers'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Can be licensed:</label>
                <v-switch v-model="patent.applyForLicense" color="success" class="required">
                </v-switch>
              </v-card-text>
              <v-card-actions class="mt-0 pt-0">
                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                    @click="clear"
                    outlined
                    block
                    depressed
                    large
                    text
                    class="primary200--text font-weight-bold"
                  >
                    Clear
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    @click="triggerFilters"
                    :disabled="!isPatentValid"
                    block
                    depressed
                    rounded
                    large
                    color="primary200"
                    class="white--text font-weight-bold"
                    data-cy="submit"
                    >Done
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <!-- Body -->
      <v-col cols="12" xl="6" lg="9" md="9" sm="12" xs="12">
        <!-- Hosting Institutions -->
        <v-row class="mb-10 justify-start" v-if="toggleTab === 'hosting-institution' && !filtered">
          <v-col
            cols="12"
            xl="3"
            lg="4"
            md="6"
            sm="6"
            xs="12"
            class="pa-3"
            v-for="institution in institutions"
            :key="'institution-' + institution.id"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="justify-center align-center"
                elevation="3"
                style="border-radius: 24px; height: 100%; "
                :class="{ 'on-hover': hover }"
                @click="filterInstitution(institution)"
              >
                <v-card-text>
                  <v-row class="text-center">
                    <v-col cols="12">
                      <v-avatar size="150px" class="rounded-xl">
                        <v-img contain :src="institution.logoUrl">
                          <template v-slot:placeholder>
                            <v-img lazy-src="@/assets/img/blur.jpg"></v-img>
                          </template>
                        </v-img>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" class="mt-12 primary300--text">
                      <b>{{ institution.name }}</b>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>

        <!-- View All -->
        <v-row v-if="toggleTab === 'view-all' && !filtered">
          <MarketplacePatentsViewAll :sortParams="sortParams"></MarketplacePatentsViewAll>
        </v-row>
        <!-- Filtered View ALl -->
        <v-row v-if="filtered">
          <MarketplacePatentsFilteredViewAll
            :filteredParams="params"
            :sortParams="sortParams"
            @changeTab="toggleChangeTab"
          ></MarketplacePatentsFilteredViewAll>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import MarketplacePatentsViewAll from './MarketplacePatentsViewAll.vue';
import MarketplacePatentsFilteredViewAll from './MarketplacePatentsFilteredViewAll.vue';

export default {
  name: 'BrowseCataloguePatents',
  components: { MarketplacePatentsViewAll, MarketplacePatentsFilteredViewAll },
  data() {
    return {
      toggleTab: 'hosting-institution',
      patent: {
        text: '',
        fillingDate: [],
        issueDate: [],
        expirationDate: [],
        patentStatus: [],
        technology: [],
        providers: [],
        applyForLicense: true,
      },
      institutions: [],
      fillingDateMenu: false,
      issueDateMenu: false,
      expirationDateMenu: false,
      patentStatusItems: [],
      technologies: [],
      providers: [],
      filtered: false,
      params: {},
      sortParams: '',
      marketplacePatentsViewAll: '',
      sortBy: null,
      itemsSortBy: [
        { text: 'Default', value: null },
        { text: 'Recently updated', value: 'updatedTimestamp', desc: true },
        { text: 'Recently added', value: 'createdTimestamp', desc: true },
        { text: 'A-Z', value: 'name', desc: false },
      ],
      queries: {},
      hasDefinedParams: {},
      initialToggleTab: '',
    };
  },
  props: {
    toggleButton: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.axios.get('/api/v1/hosting-institutions/all').then(res => {
      this.institutions = res.data;
    });

    this.axios.get('/api/v1/patent-status').then(res => {
      this.patentStatusItems = res.data.content;
    });

    this.axios.get('/api/v1/technologies').then(res => {
      this.technologies = res.data.content;
    });

    this.axios.get('/api/v1/providers/light?size=-1').then(res => {
      this.providers = res.data.content;
    });

    this.marketplacePatentsViewAll = this.$route.query.marketplacePatentsViewAll;
    if (this.marketplacePatentsViewAll) {
      this.toggleTab = 'view-all';
    }

    if (this.toggleButton) {
      const valueOfToggleButton = this.toggleButton;
      this.toggleTab = valueOfToggleButton;
    }
  },
  created() {
    this.queries = this.$route.query;
    if (this.queries) {
      let fillingDateFrom, fillingDateTo, fillingDate;
      let issueDateFrom, issueDateTo, issueDate;
      let expirationDateFrom, expirationDateTo, expirationDate;

      let fillingDateParams = this.queries.fillingDate;
      let issueDateParams = this.queries.issueDate;
      let expirationDateParams = this.queries.expirationDate;

      if (typeof fillingDateParams === 'string') {
        const fillingDateArray = fillingDateParams.split(',');
        if (fillingDateArray.length > 1) {
          fillingDateFrom = fillingDateArray[0];
          fillingDateTo = fillingDateArray[1];
        } else {
          fillingDate = fillingDateArray[0];
        }
      }

      if (typeof issueDateParams === 'string') {
        const issueDateArray = issueDateParams.split(',');
        if (issueDateArray.length > 1) {
          issueDateFrom = issueDateArray[0];
          issueDateTo = issueDateArray[1];
        } else {
          issueDate = issueDateArray[0];
        }
      }

      if (typeof expirationDateParams === 'string') {
        const expirationDateArray = expirationDateParams.split(',');
        if (expirationDateArray.length > 1) {
          expirationDateFrom = expirationDateArray[0];
          expirationDateTo = expirationDateArray[1];
        } else {
          expirationDate = expirationDateArray[0];
        }
      }

      const paramsQueries = {
        text: this.queries.text,
        providers: this.queries.providers,
        patentStatuses: this.queries.patentStatuses,
        technologies: this.queries.technologies,
        institutions: this.queries.institutions,
        fillingDateFrom: this.queries.fillingDateFrom,
        fillingDateTo: this.queries.fillingDateTo,
        issueDateFrom: this.queries.issueDateFrom,
        issueDateTo: this.queries.issueDateTo,
        expirationDateFrom: this.queries.expirationDateFrom,
        expirationDateTo: this.queries.expirationDateTo,
        ...(fillingDate && { fillingDate }),
        ...(fillingDateFrom && fillingDateTo && { fillingDateFrom, fillingDateTo }),
        ...(issueDate && { issueDate }),
        ...(issueDateFrom && issueDateTo && { issueDateFrom, issueDateTo }),
        ...(expirationDate && { expirationDate }),
        ...(expirationDateFrom && expirationDateTo && { expirationDateFrom, expirationDateTo }),
      };

      this.hasDefinedParams = Object.values(paramsQueries).some(value => value !== undefined);

      if (this.hasDefinedParams) {
        console.log('params', paramsQueries);
        this.filtered = true;
        this.params = paramsQueries;
      }
    }
  },
  watch: {
    toggleTab(newValue) {
      if (newValue === 'hosting-institution') {
        this.sortBy = '';
        this.sortParams = this.sortBy;
      }
    },
    toggleButton(newValue) {
      if (newValue) {
        this.toggleTab = newValue;
      }
    },
    '$route.query': {
      immediate: true,
      deep: true,
      handler(query) {
        if (query.filters === 'true' && query.marketplacePatentsViewAll) {
          const { ...filterParams } = query;
          if (filterParams.applyForLicense === 'true') filterParams.applyForLicense = true;
          if (filterParams.applyForLicense === 'false') filterParams.applyForLicense = false;
          if (Object.keys(filterParams).length > 0) {
            this.filtered = true;
            this.params = filterParams;
            if (filterParams.text) {
              this.patent.text = filterParams.text;
            }
            if (filterParams.applyForLicense !== undefined) {
              this.patent.applyForLicense = filterParams.applyForLicense;
            }
            if (filterParams.fillingDate) {
              this.patent.fillingDate = filterParams.fillingDate.split(',');
            } else if (filterParams.fillingDateFrom && filterParams.fillingDateTo) {
              this.patent.fillingDate = [filterParams.fillingDateFrom, filterParams.fillingDateTo];
            }
            if (filterParams.issueDate) {
              this.patent.issueDate = filterParams.issueDate.split(',');
            } else if (filterParams.issueDateFrom && filterParams.issueDateTo) {
              this.patent.issueDate = [filterParams.issueDateFrom, filterParams.issueDateTo];
            }
            if (filterParams.expirationDate) {
              this.patent.expirationDate = filterParams.expirationDate.split(',');
            } else if (filterParams.expirationDateFrom && filterParams.expirationDateTo) {
              this.patent.expirationDate = [
                filterParams.expirationDateFrom,
                filterParams.expirationDateTo,
              ];
            }
            if (filterParams.patentStatuses) {
              this.patent.patentStatus = filterParams.patentStatuses.split(',').map(Number);
            }
            if (filterParams.technologies) {
              this.patent.technology = filterParams.technologies.split(',').map(Number);
            }
            if (filterParams.providers) {
              this.patent.providers = filterParams.providers.split(',').map(Number);
            }
          }
        }
      },
    },
  },
  computed: {
    fillingDateRangeText() {
      return this.patent.fillingDate.join(' ~ ');
    },
    issueDateRangeText() {
      return this.patent.issueDate.join(' ~ ');
    },
    expirationDateRangeText() {
      return this.patent.expirationDate.join(' ~ ');
    },

    isPatentValid() {
      const patentFields = [
        ...this.patent.text,
        ...this.patent.fillingDate,
        ...this.patent.issueDate,
        ...this.patent.expirationDate,
        ...this.patent.patentStatus,
        ...this.patent.technology,
        ...this.patent.providers,
      ];

      return patentFields.some(field => field) || this.patent.applyForLicense !== undefined;
    },
  },
  methods: {
    toggleChangeTab() {
      this.clear();
    },
    clear() {
      this.patent.technology = [];
      this.patent.patentStatus = [];
      this.patent.expirationDate = [];
      this.patent.issueDate = [];
      this.patent.fillingDate = [];
      this.patent.providers = [];
      this.patent.text = '';
      this.patent.applyForLicense = true;
      this.filtered = false;
      if (this.initialToggleTab) {
        this.toggleTab = this.initialToggleTab;
      }
      if (this.$store.getters.roles && this.hasDefinedParams) {
        this.$router.push({
          path: '/marketplace/patents',
          query: {
            selectedCatalogue: 'Browse the Catalogue of Patents',
            marketplacePatentsViewAll: true,
          },
        });
      } else if (!this.$store.getters.roles && this.hasDefinedParams) {
        this.$router.push({
          path: '/public-catalogue-marketplace/patents',
          query: {
            selectedCatalogue: 'Browse the Catalogue of Patents',
            marketplacePatentsViewAll: true,
          },
        });
      }
    },
    triggerFilters() {
      const fillingDate = this.patent.fillingDate.map(fillingDate => fillingDate);
      const issueDate = this.patent.issueDate.map(issueDate => issueDate);
      const expirationDate = this.patent.expirationDate.map(expirationDate => expirationDate);
      const patentStatus = this.patent.patentStatus.map(patentStatus => patentStatus);
      const patentTechnologies = this.patent.technology.map(technology => technology);
      const providers = this.patent.providers.map(provider => provider);

      let fillingDateParams;
      let issueDateParams;
      let expirationDateParams;
      let params = {
        patentStatuses: patentStatus.join(','),
        technologies: patentTechnologies.join(','),
        providers: providers.join(','),
        text: this.patent.text,
        applyForLicense: this.patent.applyForLicense,
      };

      if (fillingDate.length === 2) {
        params.fillingDateFrom = fillingDate[0];
        params.fillingDateTo = fillingDate[1];
      } else {
        fillingDateParams = fillingDate.join(',');
        params.fillingDate = fillingDateParams;
      }

      if (issueDate.length === 2) {
        params.issueDateFrom = issueDate[0];
        params.issueDateTo = issueDate[1];
      } else {
        issueDateParams = issueDate.join(',');
        params.issueDate = issueDateParams;
      }

      if (expirationDate.length === 2) {
        params.expirationDateFrom = expirationDate[0];
        params.expirationDateTo = expirationDate[1];
      } else {
        expirationDateParams = expirationDate.join(',');
        params.expirationDate = expirationDateParams;
      }

      this.deleteEmptyProperties(params);
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },
    deleteEmptyProperties(obj) {
      if (!obj || typeof obj !== 'object') {
        return;
      }

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          if (item === null || item === undefined || item === '') {
            obj.splice(index, 1);
          } else if (typeof item === 'object') {
            this.deleteEmptyProperties(item);
            if (Object.keys(item).length === 0) {
              obj.splice(index, 1);
            }
          }
        });
      } else {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          } else if (Array.isArray(obj[key])) {
            this.deleteEmptyProperties(obj[key]);
            if (obj[key].length === 0) {
              delete obj[key];
            }
          } else if (typeof obj[key] === 'object') {
            this.deleteEmptyProperties(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          }
        }
      }
    },
    filterInstitution(institution) {
      const institutionId = institution.id;
      const params = {
        institutions: institutionId,
      };
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },
    changeSortBy(selected) {
      let params = '';

      if (selected && selected.value) {
        const sortField = selected.value;
        const sortOrder = selected.desc ? 'desc' : 'asc';
        params = `sort=${sortField}+${sortOrder}`;
        this.sortParams = params;
      } else {
        this.sortParams = '';
      }
    },
  },
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
